export const ASPECT_RATIO_9X16 = '9:16';
export const ASPECT_RATIO_16X9 = '16:9';

export const ASPECT_RATIO_LIST = [ASPECT_RATIO_9X16, ASPECT_RATIO_16X9] as const;
